import AnalyticsContext, { useAnalyticsWithProperties } from "connected-components/analytics/context"
import { ReactNode } from "react"
import { DeepReadonly } from "ts-essentials"
import { useAiTeammateContext, useThreadsContext } from "../hooks/context"
import { useExtractAiTeammateContextProperties } from "./extract-context-properties"

interface AiTeammateAnalyticsProviderProps {
  children: ReactNode
}

/**
 * Provides AI Teammate analytics context with automatic property extraction
 * and "AI Teammate" prefix for all events.
 *
 * This provider wraps children with analytics context that includes:
 * - AI Teammate context
 * - "AI Teammate" prefix for all tracked events
 *
 * Should be used within an AiTeammateProvider.
 */
export function AiTeammateAnalyticsProvider({
  children,
}: DeepReadonly<AiTeammateAnalyticsProviderProps>) {
  const aiTeammateContext = useAiTeammateContext()
  const threadsContext = useThreadsContext()

  const contextProperties = useExtractAiTeammateContextProperties(aiTeammateContext, threadsContext)

  const analyticsContextValue = useAnalyticsWithProperties(contextProperties, "AI Teammate")

  return (
    <AnalyticsContext.Provider value={analyticsContextValue}>
      {children}
    </AnalyticsContext.Provider>
  )
}

export default AiTeammateAnalyticsProvider
